import * as cryptoApi from "app/api/cryptoApi";
import { TextInput } from "app/components/FormInputs/FormInputs";
import IconCrypto from "app/components/Icon/components/IconCrypto/IconCrypto";
import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import { TranslationHelper } from "app/helpers/translationHelper";
import { UserType } from "app/types/userType";
import { Component, FormEventHandler } from "react";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
import "./CryptoFundingRequestQuote.scss";

type Props = {
  type: string;
  onSelectCoin: Function;
  onChangeAmount: Function;
  requestQuote: FormEventHandler;
  selectedCoin: string;
  user: UserType;
  quoteError: string;
  quoteLoading: boolean;
  amountSending: number;
};

type State = {
  currencyList: Array<string>;
  currencyLoading: boolean;
  error: string;
};

class CryptoFundingRequestQuote extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      currencyList: [],
      currencyLoading: true,
      error: "",
    };
    this.getCurrencyList();
  }
  getCurrencyList = () => {
    cryptoApi
      .getCryptoCurrencies()
      .then((resp: any) => {
        if (resp.data.currencies) {
          this.setState({
            currencyList: resp.data.currencies,
            currencyLoading: false,
          });
        }
      })
      .catch((error: any) => {
        let errorMessage = "";

        if (error.response) {
          if (error.response.data && error.response.data.errors.length > 0) {
            errorMessage = error.response.data.errors[0].messages[0];
          }
        }
        this.setState({
          currencyLoading: false,
          error: errorMessage,
        });
        throw error;
      });
  };

  renderSelectOption = value => {
    return (
      <span className="crypto-funding-request-quote__currency-option">
        <IconCrypto name={value} />
        <FormattedMessage
          tagName="span"
          id={TranslationHelper.getTranslationIdForCryptoCurrencyType(value)}
        />{" "}
        {`(${value.replace(/_/g, "-")})`}
      </span>
    );
  };

  renderSelect = () => {
    let options: Array<Object> = [];
    this.state.currencyList.forEach(value => {
      options.push({
        value: value,
        label: this.renderSelectOption(value),
      });
    });

    let defaultValue: Object = {
      value: "",
      label: <FormattedMessage id="cashier-select-coin" />,
    };

    if (this.props.selectedCoin) {
      console.log("selectedCoin", this.props.selectedCoin);
      defaultValue = {
        value: this.props.selectedCoin,
        label: this.renderSelectOption(this.props.selectedCoin),
      };
    }

    return (
      <Select
        name="currencies"
        defaultValue={defaultValue}
        onChange={this.props.onSelectCoin}
        className="form-control"
        options={options}
        isSearchable={false}
      />
    );
  };
  render() {
    const {
      type,
      onChangeAmount,
      requestQuote,
      user,
      quoteError,
      quoteLoading,
      selectedCoin,
      amountSending,
    } = this.props;
    const { currencyLoading, error } = this.state;
    const amountLabel =
      type === "DEPOSIT"
        ? "cashier-amount-sending-deposit"
        : "cashier-amount-sending-withdraw";

    if (quoteLoading || currencyLoading) {
      return <LoadingSpinner />;
    }

    return (
      <div className="crypto-funding-request-quote">
        <form onSubmit={requestQuote}>
          <div className="crypto-funding-request-quote__currencies">
            <label className="text-input__label" htmlFor="currencies">
              <FormattedMessage tagName="span" id="cashier-select-coin" />
            </label>
            {this.renderSelect()}
          </div>
          <div className="crypto-funding-request-quote__amountSending">
            <label className="text-input__label" htmlFor="amountSending">
              <FormattedMessage tagName="span" id={amountLabel} />
              {` (${user["currencyCode"]})`}
            </label>
            <TextInput
              type="text"
              name="amountSending"
              id="amountSending"
              onChange={onChangeAmount}
              label={null}
            />
            <div className="error-msg">{error || quoteError}</div>
          </div>
          <button
            id="deposit__button"
            type="submit"
            disabled={!this.props.selectedCoin || !amountSending}
          >
            <FormattedMessage tagName="span" id="cashier-request-quote" />
          </button>
        </form>
      </div>
    );
  }
}

export default CryptoFundingRequestQuote;
